import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useArchCatNode from '../_ARCH_CAT/useArchCatNode.jsx'
import meta from './metaCatLs.mjs'
import PropertiesPane from './PropertiesPaneCatLs.jsx'

export default () => {
    const ArchCatNode = useArchCatNode()

    return extendNode(ArchCatNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^(LS)$/.test(type)
        },

        canMountType(map, node, type) {
            return /^(CAT|MARK)$/.test(type)
        },

        getStyle(map, node) {
            return {
                ...ArchCatNode.getStyle.call(this, map, node),
                backgroundColor: Color.PURPLE,
            }
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
                {type: 'MARK'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'LS'},
            ]
        },
    })
}
